import React from "react";
import { useState } from "react";
import { TemplateItem } from "./TemplateItem.jsx";

export function GroupBlock({ name, isPersistent, isUngrouped, openTemplateGroups, setOpenTemplateGroups, activeTemplateId, mode, byGroup, ungrouped, setTemplates, setTemplateGroups, templateItemProps }) {
  const open = isUngrouped ? !!openTemplateGroups['__ungrouped__'] : !!openTemplateGroups[name];
  function setOpen(val) {
    const key = isUngrouped ? '__ungrouped__' : name;
    setOpenTemplateGroups(prev => ({...prev, [key]: typeof val==='function' ? val(prev[key]) : val}));
  }
  const [renaming, setRenaming] = useState(false);
  const [renameVal, setRenameVal] = useState(name);
  const items = isUngrouped ? (ungrouped||[]) : ((byGroup||{})[name] || []);
  const hasActive = items.some(t => t.id === activeTemplateId && mode==='draw');
  React.useEffect(() => { if (hasActive) setOpen(true); }, [hasActive]);

  function doRename() {
    const nv = renameVal.trim();
    if (!nv || nv === name) { setRenaming(false); setRenameVal(name); return; }
    setTemplates(ts => ts.map(t => (t.groupName||'').trim()===name ? {...t,groupName:nv} : t));
    setTemplateGroups(gs => gs.map(g => g===name ? nv : g));
    setRenaming(false);
  }
  function doDelete() {
    const msg = items.length > 0
      ? `Ištrinti grupę "${name}"? ${items.length} šablon${items.length===1?'as':'ų'} bus perkeltas į nepriskirtuosius.`
      : `Ištrinti grupę "${name}"?`;
    if (!window.confirm(msg)) return;
    setTemplates(ts => ts.map(t => (t.groupName||'').trim()===name ? {...t,groupName:''} : t));
    setTemplateGroups(gs => gs.filter(g => g!==name));
  }

  return (
    <div style={{marginBottom:1}}>
      <div style={{display:'flex',alignItems:'center',gap:4,padding:'5px 6px 5px 8px',
        background: hasActive ? '#fff3f0' : '#f3f4f6',
        borderLeft: hasActive ? '3px solid #735DFF' : '3px solid transparent',
        userSelect:'none'}}>
        <span onClick={()=>setOpen(o=>!o)}
          style={{fontSize:9,color:'#383853',cursor:'pointer',display:'inline-block',
            transform:open?'rotate(90deg)':'rotate(0deg)',transition:'transform 0.15s',flexShrink:0}}>▶</span>
        {renaming ? (
          <input autoFocus value={renameVal}
            onChange={e=>setRenameVal(e.target.value)}
            onBlur={doRename}
            onKeyDown={e=>{if(e.key==='Enter')doRename();if(e.key==='Escape'){setRenaming(false);setRenameVal(name);}}}
            style={{flex:1,border:'1px solid #735DFF',borderRadius:4,padding:'1px 5px',fontSize:11,fontWeight:700,outline:'none'}}
            onClick={e=>e.stopPropagation()} />
        ) : (
          <span onClick={()=>setOpen(o=>!o)}
            style={{flex:1,fontSize:11,fontWeight:700,color:'#374151',cursor:'pointer',
              whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
            {name}
          </span>
        )}
        <span style={{fontSize:10,color:'#9ca3af',flexShrink:0,marginRight:2}}>{items.length}</span>
        {isPersistent && !renaming && (
          <>
            <button onClick={e=>{e.stopPropagation();setRenaming(true);setRenameVal(name);}}
              title="Pervadinti grupę"
              style={{background:'none',border:'none',color:'#c4c9cc',cursor:'pointer',fontSize:10,padding:'0 1px',lineHeight:1,flexShrink:0}}>✏</button>
            <button onClick={e=>{e.stopPropagation();doDelete();}}
              title="Ištrinti grupę"
              style={{background:'none',border:'none',color:'#e5e7eb',cursor:'pointer',fontSize:13,padding:'0 1px',lineHeight:1,flexShrink:0}}>×</button>
          </>
        )}
      </div>
      {open && (
        <div style={{paddingLeft:8,borderLeft:'2px solid #f0f0f0',marginLeft:8}}>
          {items.length===0
            ? <div style={{padding:'6px 8px',fontSize:10,color:'#9ca3af',fontStyle:'italic'}}>Grupė tuščia</div>
            : items.map(tmpl => <TemplateItem key={tmpl.id} tmpl={tmpl} {...(templateItemProps||{})} />)
          }
        </div>
      )}
    </div>
  );
}
